import { Typography } from '@/domains/core/tamagoshiTailwind/components/Typography/Typography';

import { useTranslationsFooterContactNewsletter } from '../../hooks/useTranslations';

export const NewsletterTitle = () => {
  const translations = useTranslationsFooterContactNewsletter();
  return (
    <div className="flex flex-col gap-xs text-center">
      <Typography as="span" scale="title3" weight="bold" className="w-full">
        {translations.title}
      </Typography>
      <Typography
        as="span"
        scale="body2"
        className="w-full text-foundation-primary"
      >
        {translations.subtitle}
      </Typography>
    </div>
  );
};
